import React, { useEffect } from 'react';
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  Typography
} from '@mui/material';
import { getRouteQRCode } from 'actions/routePlannerActions';
import { connect } from 'react-redux';

const QRCodeDialog = ({
  open,
  handleClose,
  routeEircode,
  getRouteQRCode,
  loadingQRCode,
  qrCode,
  qrCodeError
}) => {

  useEffect(() => {
    getRouteQRCode(routeEircode);
  }, [getRouteQRCode, routeEircode]);

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}>
      <DialogTitle id="simple-dialog-title">QR Code</DialogTitle>
      <div style={{ padding: '40px 80px 80px 80px' }}>
        {loadingQRCode && <CircularProgress />}
        {!loadingQRCode && qrCode && (
          <img alt="QR Code" src={`data:image/png;base64, ${qrCode}`} />
        )}
        {!loadingQRCode && qrCodeError && (
          <Typography>Could not find QR Code</Typography>
        )}
      </div>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  qrCode: state.routePlanner.qrCode,
  loadingQRCode: state.routePlanner.loadingQRCode,
  qrCodeError: state.routePlanner.qrCodeError
});

const mapDispatchToProps = dispatch => ({
  getRouteQRCode: (devRouteName: string) => dispatch(getRouteQRCode(devRouteName))
});

export default connect(mapStateToProps, mapDispatchToProps)(QRCodeDialog);
